exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pc .checkout-save-cart .alert {\n  margin-top: 15px;\n}\n\n.pc .checkout-save-cart .form-group {\n  margin-bottom: 0;\n}\n\n.pc .checkout-save-cart .form-group:not(:first-child) {\n  margin-top: 15px;\n}\n\n", ""]);

// exports
